export const mapCrmObjectData = crmObject => {
  var _crmObject$properties, _crmObject$properties2, _crmObject$properties3, _crmObject$properties4, _crmObject$properties5, _crmObject$properties6;
  return {
    id: crmObject.properties.hs_content_id.value,
    name: (_crmObject$properties = (_crmObject$properties2 = crmObject.properties.hs_name) === null || _crmObject$properties2 === void 0 ? void 0 : _crmObject$properties2.value) !== null && _crmObject$properties !== void 0 ? _crmObject$properties : '',
    imgSrc: (_crmObject$properties3 = (_crmObject$properties4 = crmObject.properties.hs_screenshot_url) === null || _crmObject$properties4 === void 0 ? void 0 : _crmObject$properties4.value) !== null && _crmObject$properties3 !== void 0 ? _crmObject$properties3 : '',
    containerType: (_crmObject$properties5 = (_crmObject$properties6 = crmObject.properties) === null || _crmObject$properties6 === void 0 || (_crmObject$properties6 = _crmObject$properties6.hs_container_type) === null || _crmObject$properties6 === void 0 ? void 0 : _crmObject$properties6.value) !== null && _crmObject$properties5 !== void 0 ? _crmObject$properties5 : ''
  };
};
export const notHasProperty = property => ({
  operator: 'NOT_HAS_PROPERTY',
  property
});
export const propertyNotEquals = (property, value) => ({
  operator: 'NEQ',
  property,
  value
});